import { OnRaceBetsSchema } from './OnRaceBets.styles';

export const onRaceBetStyles: OnRaceBetsSchema = {
  wrapper: {
    mb: '2',
    bg: 'rgba(78, 178, 255, 0.14)',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.3)',
    border: 'node',
    borderRadius: 'md',
    flexDirection: 'column',
    py: '2',
  },
  headerWrapper: {
    px: '3',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontSize: 'sm',
    fontWeight: 'normal',
    fontFamily: 'accent',
    color: 'white',
  },
  headerCountText: {
    ml: '1',
    fontSize: '2xs',
    fontWeight: 'semibold',
    color: 'white',
  },
  headerExpandButton: {
    variant: 'unstyled',
    ml: 'auto',
    mr: '1',
    color: 'white',
    boxSize: '7',
  },
  toggleIcon: {
    boxSize: '4',
  },
  betsContainer: {
    flexDirection: 'column',
  },
  betCategoryWrapper: {
    alignItems: 'center',
    mt: '2',
  },
  betCategory: {
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'alpha.700',
  },
  betCategoryCount: {
    fontSize: 'xs',
    fontWeight: 'semibold',
    color: 'alpha.700',
    ml: '1',
  },
  divider: {
    borderWidth: 'px',
    opacity: '1',
    borderColor: 'blackAlpha.400',
    mt: '1.5',
  },
  betRow: {
    py: '2',
    px: '2',
    gap: '2',
    bg: 'blackAlpha.300',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    borderRadius: 'base',
    mb: '1',
    _last: {
      mb: '0',
    },
  },
  betRowDivider: {
    bg: 'blackAlpha.300',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    borderRadius: 'base',
    mb: '1',
    p: '2',
    _last: {
      mb: '0',
    },
  },
  groupDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'blackAlpha.400',
  },
  categoryIcon: {
    color: 'alpha.400',
    boxSize: '6',
  },
  groupContainer: {
    flexDir: 'column',
    py: 2,
    px: '3',
    border: 'none',
    boxShadow: 'none',
  },
  groupTitleText: {
    fontFamily: 'accent',
    color: 'alpha.400',
    fontSize: 'sm',
    fontWeight: 'normal',
  },
  runnerText: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  runnerBarrierText: {
    color: 'white',
    fontSize: 'xs',
  },
  stakeText: {
    color: 'alpha.400',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  potentialWinningsText: {
    color: 'alpha.400',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  subtitleText: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'normal',
  },
  exoticsPositionText: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'extrabold',
    w: 9,
  },
  viewMoreButton: {
    alignItems: 'center',
    justifyContent: 'center',
    mb: -2,
    borderTopRadius: 0,
    height: 8,
  },
  viewMoreButtonText: {
    fontWeight: 'normal',
    fontSize: 'sm',
    textTransform: 'uppercase',
    textShadow: 'none',
  },
  srmBlendedLegContainer: {
    flexDir: 'row',
    flex: '1',
  },
  srmBlendedRunnerText: {
    width: 32,
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'xs',
    textTransform: 'capitalize',
  },
  srmMarketText: {
    fontWeight: 'bold',
    color: 'white',
    fontSize: 'xs',
  },
  srmBlendedWrapper: {
    flexDir: 'column',
    flex: 1,
  },
  flexiText: {
    fontWeight: 'normal',
    color: 'white',
    fontSize: 'xs',
  },
  flexiStakeText: {
    width: '16',
    color: 'white',
  },
  flexiStakeValueText: {
    color: 'alpha.400',
    fontWeight: 'bold',
  },
};
